import { useModalProvider } from '../../../../../Providers/ModalProvider';
import { ConfirmationModalContainer, ConfirmationModalContent} from '../../../../../Constants/StyledComponentsConfirmationModals';
import * as MdIcons from 'react-icons/md';
import ConfirmationModalButton, { buttonColor } from '../../../../../Components/ConfirmationModalButton/ConfirmationModalButton';
import { MobergFontFamily } from '../../../../../Components/MobergFont/MobergFont';
const DeleteKeyboardShortcutModal = ({ onConfirm }) => {
    const { close } = useModalProvider()

    function handleDeleteAnnotation() {
        onConfirm?.()
        close()
    }

    return (
        <ConfirmationModalContainer>
            <ConfirmationModalContent>
                <MdIcons.MdOutlineError size={81} style={{color: "#AEB7C6", marginBottom: "20px"}}/>
                <h1 style={{fontFamily: MobergFontFamily.HEADER, fontStyle: "normal", fontWeight: "700", fontSize: "24px", lineHeight: "110%", color: "var(--color-text-primary)"}}>Delete shortcut?</h1>
                <p>You are about to delete the selected annotation shortcut.</p>
                <p>This action can not be undone.</p>
            </ConfirmationModalContent>

            <ConfirmationModalButton
                buttonText="Yes, delete shortcut"
                color={buttonColor.redFill}
                onClickFxn={handleDeleteAnnotation}
                buttonStyle={{marginTop: "18px"}}
            />

            <ConfirmationModalButton
                buttonText="Cancel"
                color={buttonColor.blueOutline}
                onClickFxn={close}
                buttonStyle={{marginTop: "18px"}}
            />
        </ConfirmationModalContainer>
    )
}


export default DeleteKeyboardShortcutModal;